
export const columnAnalysisTDef = () => {
    let analysisItems = [];
    analysisItems.push(
        {accessorKey: "sn", header: "#", cell: ({getValue}) =>
                <div style={{padding: "0px 15px"}}>{getValue()}
                </div>});


        analysisItems.push(
            {
                accessorKey: "title",
                header: "Topic Title",
                cell: ({getValue}) => {
                    return (
                        <div className="row1">
                            <small>{getValue()}</small>
                        </div>
                    )
                },
            },
            {
                accessorKey: "topic_count",
                header: "Topic Count",
                cell: ({getValue}) => {
                    return (
                        <div className="row1">
                            <small>{getValue()}</small>
                        </div>
                    )
                },
            });

    return analysisItems;
}
